module.exports = __webpack_public_path__ + "static/media/dismiss-green.4ca08331.svg";